import Checkbox from './checkbox'

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/checkbox/index.js